import React, {useState} from "react"
import {Button, Modal} from "react-bootstrap"
import {delOrgInvitedUser, delTeamInvitedUser, putOrgInvitedUser, putTeamInvitedUser} from "../../lib/api";
import DropdownScope from "./DropdownScope";

function InvitedMemberEdit(props: {
  invitedUser: any,
  loadData: any,
  show: boolean;
  onHide: () => void;
}) {
  const {invitedUser: invitedUser, loadData, show, onHide} = props;
  const [error, setError] = useState(null);
  const [scope, setScope] = useState('');
  const [enabled, setEnabled] = useState(true);

  function capitalize(s: string) {
    return s.replace( /(^|\s)([a-z])/g , function(m,p1,p2){ return p1+p2.toUpperCase(); } );
  }

  function showModal() {
    console.error('show')
    setScope(capitalize(invitedUser.scope));
    setEnabled(true);
    setError(null);
  }

  function removeUser() {
    const answer = window.confirm("Are you sure you want to remove invited member?")
    if (!answer) {
      return;
    }
    if (invitedUser.teamId) {
      delTeamInvitedUser(invitedUser)
        .then(responseHandler);
    } else {
      delOrgInvitedUser(invitedUser)
        .then(responseHandler);
    }
  }

  function editUser() {
    setError(null);
    setEnabled(false);

    if (invitedUser.teamId) {
      putTeamInvitedUser(invitedUser, scope.toLowerCase())
        .then(responseHandler);
    } else {
      putOrgInvitedUser(invitedUser, scope.toLowerCase())
        .then(responseHandler);
    }
  }

  function responseHandler(response: any) {
    setEnabled(true);
    if (response.ok) {
      onHide()
      loadData()
    } else {
      // @ts-ignore
      response.json().then(json => {
        setError(json?.error);
      });
    }
  }

  if (!invitedUser) {
    return null;
  }

  let title: string;
  const scopes = ['Member'];
  if (invitedUser.teamId) {
    title = 'Edit Invited Member';
    scopes.push('Guest');
  } else {
    title = 'Edit Organization Member';
    scopes.push('Admin');
  }
  if (scopes.indexOf(capitalize(invitedUser.scope)) === -1) {
    scopes.push(capitalize(invitedUser.scope));
  }

  return (
    <Modal show={show}
           className="member-edit"
           animation={false}
           onShow={showModal}
           onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row pb-3">
          <div className="col">
            {invitedUser.email}
          </div>
        </div>
        <DropdownScope titleScope="Change to" scope={scope} setScope={setScope} scopes={scopes}/>
        {error ?
          (
            <div className="row error">
              <div className="col">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
      </Modal.Body>
      <Modal.Footer>
        <div className="row px-0">
          <div className="col text-right">
            <Button
              variant="secondary"
              className="mx-4"
              onClick={removeUser}
              disabled={!enabled}
            >
              Remove Member
            </Button>
            <Button
              variant="secondary"
              className="ml-2"
              onClick={onHide}
              disabled={!enabled}
            >
              Cancel
            </Button>
            <Button
              onClick={editUser}
              style={{marginLeft: "10px"}}
              variant="primary"
              disabled={!enabled}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default InvitedMemberEdit;
